import { IPublishTermsInfo } from './types';

export const DEFAULT_RESPONSE: IPublishTermsInfo = {
  isNewPublishTerms: false,
};
